export default {
  INITIAL_FETCH: "CAMPAIGNS/INITIAL_FETCH",
  RECEIVED_CAMPAIGNS: "CAMPAIGNS/RECEIVED_CAMPAIGNS",
  RESET_CAMPAIGNS: "CAMPAIGNS/RESET_CAMPAIGNS",
  SET_ERROR: "CAMPAIGNS/SET_ERROR",
  RESET_AND_ADD_NEW_CAMPAIGNS: "CAMPAIGNS/RESET_AND_ADD_NEW_CAMPAIGNS",
};

export const MINIMUM_WAIT_FOR_RESPONSE = 1000;
export const WAIT_TO_SHOW_CONTENT = 1000;
